"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainedError = void 0;
/**
 * Chained Error Error.
 */
class ChainedError extends Error {
    constructor(cause, message) {
        super(`${message}: ${cause.message}`);
        this.cause = cause;
        // Set error name as constructor name, make it not enumerable to keep native Error behavior
        // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/new.target#new.target_in_constructors
        // see https://github.com/adriengibrat/ts-custom-error/issues/30
        Object.defineProperty(this, 'name', {
            value: new.target.name,
            enumerable: false,
            configurable: true,
        });
        // Manually fixup prototype chain because Error isn't a real class, and
        // the wrong thing happens by default.
        // See https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-wor
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.ChainedError = ChainedError;
//# sourceMappingURL=ChainedError.js.map